import React from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative pt-24 pb-20 md:pt-32 md:pb-28 px-4 overflow-hidden" data-id="element-107">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[500px] bg-gold-500/10 blur-[120px] rounded-full pointer-events-none" data-id="element-108" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-109">
        <div className="animate-[fadeInUp_0.8s_ease-out_both]" data-id="element-110">
          <div className="inline-block mb-6 px-4 py-1.5 rounded-full border border-gold-500/30 bg-gold-500/10 text-gold-400 text-sm font-semibold tracking-wide uppercase" data-id="element-111">
            Método Caudal
          </div>

          <h1 className="font-serif text-4xl md:text-6xl lg:text-7xl font-bold leading-tight mb-8 text-white" data-id="element-112">
            El Sueldo No Es el Problema.
            <br data-id="element-113" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold-300 to-gold-600" data-id="element-114">
              El Problema Es Que Nadie Te Enseñó a Administrarlo.
            </span>
          </h1>

          <p className="text-lg md:text-xl text-gray-300 leading-relaxed max-w-3xl mx-auto mb-12 font-light" data-id="element-115">
            Descubrí el{' '}
            <strong className="text-white font-semibold" data-id="element-116">
              Sistema de Presupuesto Inverso
            </strong>{' '}
            que usó una generación entera de personas comunes para dejar de
            vivir al límite y empezar a construir riqueza real — sin ganar más,
            sin privarse de todo, y sin hojas de cálculo imposibles.
          </p>

          <CTAButton data-id="element-117" />
        </div>
      </div>
    </section>;
}